import React, { Component } from "react";
import { Card, Col, Row, Form, Button, Table, Spinner } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { reportService } from "../../Services/reportService";
import Select from "react-select";

const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

const shipmentCategoryOptions = [
  { value: null, label: "All" },
  { value: "Commercial", label: "Commercial" },
  { value: "Personal ( New)", label: "Personal (New)" },
  { value: "Relocation", label: "Relocation" },
  { value: "Mix ( Relocation %26 New)", label: "Mix (Relocation & New)" },
];

class Performance extends Component {
  state = {
    reportObj: [],
    startDate: "",
    endDate: "",
    loader: false,
    shipmentCategory: null,
    totals : {
      revenue: 0,
      cost: 0,
      profit: 0,
      profitPercentage: 0,
    }
  };

  componentDidMount() {
    this.componentRef = React.createRef();
    this.getPerformanceReportData();
  }

  // Fetch data with optional filters
  getPerformanceReportData = () => {
    this.setState({ loader: true });

    const { startDate, endDate, shipmentCategory } = this.state;

    let params = {};

    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (shipmentCategory && shipmentCategory.value !== null) params.shipment_category = shipmentCategory.value;

    reportService.getPerformanceReort(params).then((result) => {
      if (result.status === true) {
        let totalrevenue = result.data.reduce((acc, item) => acc+= (item.invoices?.invoice_gross_amount || 0) ,0)
        let totalcost = result.data.reduce((acc, item) => acc+= (item?.costs?.cost_gross_amount || 0) ,0)
        let totalprofit = totalrevenue - totalcost
        let totalprofitPercentage = totalprofit !== 0 && totalcost !== 0 ? (totalprofit / totalcost) * 100 : 0
        this.setState({ 
          reportObj: result.data, 
          loader: false,
          totals : {
            revenue : totalrevenue,
            cost : totalcost,
            profit : totalprofit,
            profitPercentage : totalprofitPercentage,
          }
        });
      } else {
        toast.info("Something went wrong");
      }
      this.setState({ loader: false });
    });
  };

  // Handle date selection
  handleDateChange = (e) => {
    const { name, value } = e.target;
    let dateKey = name === "start_date" ? "startDate" : "endDate";

    const selectedDate = new Date(value).getTime();
    this.setState({ [dateKey]: selectedDate }, () => {
      const { startDate, endDate } = this.state;

      if (startDate && endDate) {
        if (startDate > endDate) {
          this.setState({ startDate: "", endDate: "" });
          toast.info("Start date cannot be greater than end date.");
        } else {
          this.getPerformanceReportData();
        }
      }
    });
  };

  // Handle shipment category selection
  handleShipmentCategoryChange = (selectedOption) => {
    this.setState({ shipmentCategory: selectedOption }, () => {
      this.getPerformanceReportData();
    });
  };

  exportToExcel = () => {
    const { startDate, endDate, shipmentCategory } = this.state;

    let params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (shipmentCategory && shipmentCategory.value !== null) params.shipment_category = shipmentCategory.value;

    reportService.exportPerformanceReort(params).then((result) => {
      if (result.status === true) {
        window.location.href = `${REACT_APP_API_BASEURL}/${result.data}`;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  render() {
    const { reportObj, loader, shipmentCategory, totals, } = this.state;
    

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Performance</h4>
        </div>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>Shipment Category</Form.Label>
              <Select
                styles={{
                  valueContainer: (provided) => ({
                    ...provided,
                    height: "calc(2.15rem + 2px)",
                    overflowY: "visible",
                  }),
                  control: (provider) => ({
                    ...provider,
                    borderColor: "#d8dbe0",
                    boxShadow: "0 0 0 0px #d8dbe0",
                  }),
                  placeholder: (provider) => ({
                    ...provider,
                    color: "#d8dbe0",
                  }),
                }}
                options={shipmentCategoryOptions}
                value={shipmentCategory}
                onChange={this.handleShipmentCategoryChange}
              />
            </Col>
            <Col md={3}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={this.handleDateChange}
              />
            </Col>
            <Col md={3}>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                max={new Date().toISOString().split("T")[0]}
                onChange={this.handleDateChange}
              />
            </Col>
            <Col md={3} className="d-flex justify-content-end mt-3">
              <Button className="me-2 ps-4 pe-4" variant="success" onClick={this.exportToExcel}>
                Excel
              </Button>
              <ReactToPrint
                trigger={() => <Button variant="secondary" className="ps-4 pe-4">Print</Button>}
                content={() => this.componentRef}
                bodyClass="printElement m-5"
              />
            </Col>
          </Row>

          <Row className="printElement" ref={(el) => (this.componentRef = el)}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Job Number</th>
                  <th>Date</th>
                  <th>Customer Name</th>
                  <th>Shipment Category</th>
                  <th>Origin</th>
                  <th>Destination</th>
                  <th>Revenue</th>
                  <th>Cost</th>
                  <th>Profit</th>
                  <th>Profit in %</th>
                </tr>
              </thead>
              {loader ? (
                <tbody>
                  <tr>
                    <td colSpan={10} className="text-center">
                      <Spinner animation="border" />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {reportObj.length > 0 ? (
                    reportObj.map((item, index) => {
                      // let rev = item.invoices?.invoice_lc_amount || 0;
                      // let cost = item?.costs?.cost_lc_amount || 0;
                      let rev = item.invoices?.invoice_gross_amount || 0;
                      let cost = item?.costs?.cost_gross_amount || 0;
                      let profit = rev - cost;
                      let profitPer = profit !== 0 && cost !== 0 ? (profit / cost) * 100 : 0;
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.job_token}</td>
                          <td>{moment(item?.created_at).format("DD-MM-YYYY")}</td>
                          <td>{item?.customer_details?.name || "-"}</td>
                          <td>{item?.general_details?.shipment_category || "-"}</td>
                          <td>{item?.shipment_details?.origin || "-"}</td>
                          <td>{item?.shipment_details?.destination || "-"}</td>
                          <td>{rev.toFixed(2)}</td>
                          <td>{cost.toFixed(2)}</td>
                          <td>{profit.toFixed(2)}</td>
                          <td>{profitPer.toFixed(2)}</td>
                        </tr>
                      );
                    })
                  )
                  : (
                    <tr><td colSpan={10} className="text-center">Data Not Found</td></tr>
                  )}
                  { <tr >
                   <td colSpan={7}>Total</td>
                   <td>{totals.revenue.toFixed(2)}</td>
                   <td>{totals.cost.toFixed(2)}</td>
                   <td>{totals.profit.toFixed(2)}</td>
                   <td>{totals.profitPercentage.toFixed(2)} %</td>
                 </tr>}
                </tbody>
              )}
            </Table>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { Performance };



